export default function OwnerNotifySms() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Notify via SMS
            </div>
            <div className="page-sub" id="page-sub">
              Notifications › SMS Broadcast
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="stat-grid mb16">
            <div className="stat-card">
              <div className="stat-icon">📤</div>
              <div className="stat-label">Tenants</div>
              <div className="stat-value">3</div>
              <div className="stat-delta delta-neu">Total registered</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Active</div>
              <div className="stat-value">3</div>
              <div className="stat-delta delta-up">Currently residing</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⏳</div>
              <div className="stat-label">KYC Pending</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-dn">Awaiting verification</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💸</div>
              <div className="stat-label">Bill Due</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-dn">Tenants with due bills</div>
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 340px",
              gap: 16,
              alignItems: "start",
            }}
          >
            <div className="card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 16,
                  paddingBottom: 12,
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <span style={{ fontSize: 18 }}>📱</span>
                <div style={{ fontSize: 14, fontWeight: 700 }}>
                  Send SMS Notification
                </div>
              </div>
              <div className="form-group mb12">
                <label>Send via API</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select id="po-api-sel-sms" style={{ flex: 1 }}>
                    <option value={1}>MSG91 Primary</option>
                  </select>
                  <span
                    style={{
                      fontSize: 10,
                      padding: "3px 8px",
                      borderRadius: 99,
                      background: "#EAF3DE",
                      color: "#27500A",
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                    }}
                  >
                    ✓ Active
                  </span>
                </div>
                <div className="input-hint" style={{ marginTop: 3 }}>
                  Only active APIs shown.{" "}
                  <span
                    onclick="showPage('po-api-sms',document.querySelector('[data-id=po-api-sms]'))"
                    style={{
                      color: "var(--blue)",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Manage SMS APIs →
                  </span>
                </div>
              </div>
              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  marginBottom: 12,
                }}
              />
              <div className="form-group mb12">
                <label>Recipients</label>
                <select
                  id="po-recp-sel-sms"
                  onchange="poToggleCustomInput('sms',this.value)"
                >
                  <option value="all">All Tenants (3)</option>
                  <option value="active">Active Tenants (3)</option>
                  <option value="kyc_pending">KYC Pending (1)</option>
                  <option value="kyc_not_applied">KYC Not Applied (1)</option>
                  <option value="due_bill">Bill Due Tenants (1)</option>
                  <option value="custom">Custom Selection</option>
                </select>
              </div>
              <div
                id="po-custom-box-sms"
                style={{ display: "none", marginBottom: 12 }}
              >
                <label
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    display: "block",
                    marginBottom: 5,
                  }}
                >
                  Mobile Numbers (one per line)
                </label>
                <textarea
                  id="po-custom-input-sms"
                  rows={4}
                  placeholder="919044004486
            919173984850"
                  oninput="poCountRecipients('sms')"
                  style={{ width: "100%", fontSize: 12, resize: "vertical" }}
                  defaultValue={""}
                />
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginTop: 3,
                  }}
                >
                  Recipients: <strong id="po-count-sms">0</strong>
                </div>
              </div>
              <div className="form-group mb12">
                <label>Message *</label>
                <textarea
                  id="po-msg-body-sms"
                  rows={5}
                  placeholder="Type your message or use a template from the right…"
                  style={{ width: "100%", resize: "vertical" }}
                  defaultValue={""}
                />
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-tertiary)",
                    marginTop: 4,
                  }}
                >
                  Use {"{"}name{"}"}, {"{"}room{"}"}, {"{"}amount{"}"}, {"{"}
                  due_date
                  {"}"}, {"{"}month{"}"} as placeholders
                </div>
              </div>
              <div className="form-group mb12">
                <label>Schedule</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="po-sched-sms"
                      defaultValue="now"
                      defaultChecked=""
                      onchange="toggleSchedTime('po-sms',this.value)"
                    />{" "}
                    Send Now
                  </label>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="po-sched-sms"
                      defaultValue="later"
                      onchange="toggleSchedTime('po-sms',this.value)"
                    />{" "}
                    Schedule Later
                  </label>
                </div>
                <div
                  id="sched-fields-po-sms"
                  style={{ display: "none", marginTop: 8 }}
                >
                  <input
                    type="datetime-local"
                    style={{
                      fontSize: 12,
                      padding: "6px 10px",
                      border: "0.5px solid var(--border-mid)",
                      borderRadius: 7,
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <button
                onclick="poSendNotification('SMS','sms')"
                style={{
                  background: "#534AB7",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 24px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                📱 Send SMS Notification
              </button>
            </div>
            <div className="card">
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
                Message Templates
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Rent Due Reminder
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        rent
                      </span>{" "}
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        reminder
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('sms',1)"
                    style={{
                      padding: "4px 12px",
                      background: "#534AB7",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Hi{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  , your rent of ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}amount{"}"}
                  </span>{" "}
                  is due on{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}date{"}"}
                  </span>
                  . Please pay on time to avoid late fees. Pay now:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Payment Confirmation
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        payment
                      </span>{" "}
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        confirmation
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('sms',2)"
                    style={{
                      padding: "4px 12px",
                      background: "#534AB7",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  , ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}amount{"}"}
                  </span>{" "}
                  received successfully for{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}month{"}"}
                  </span>
                  . Thank you! Download receipt:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Late Fee Alert
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        late fee
                      </span>{" "}
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        alert
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('sms',3)"
                    style={{
                      padding: "4px 12px",
                      background: "#534AB7",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Hi{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  , a late fee of ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}fee{"}"}
                  </span>{" "}
                  has been added to your account. Total due: ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}amount{"}"}
                  </span>
                  . Pay now:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      KYC Pending
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        kyc
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('sms',4)"
                    style={{
                      padding: "4px 12px",
                      background: "#534AB7",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  , your KYC verification is pending. Please upload your
                  documents to avoid service disruption:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Subscription Expiry
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        subscription
                      </span>{" "}
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        expiry
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('sms',5)"
                    style={{
                      padding: "4px 12px",
                      background: "#534AB7",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Hi{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  , your{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}plan{"}"}
                  </span>{" "}
                  plan expires on{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}date{"}"}
                  </span>
                  . Renew now to continue uninterrupted access:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      OTP Verification
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        otp
                      </span>{" "}
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        security
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('sms',6)"
                    style={{
                      padding: "4px 12px",
                      background: "#534AB7",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Your NestManager OTP is{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}otp{"}"}
                  </span>
                  . Valid for 10 minutes. Do not share with anyone.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
